<span class="mdi mdi-{{icon}}"
    [ngStyle]="{ 'font-size': size, 'line-height': size, 'height': size, 'width': size, 'font-weight': fontweight }">
</span>